import { makeStyles } from '@mui/styles';
// import theme from "../../../../theme/theme";

export const styles = makeStyles({
    expandText :{ 
        textDecoration: 'underline',
        cursor: 'pointer',
        marginLeft: 5,
        color: '#3300ff'
       },
    modalBank: {
        [`& .css-1t1j96h-MuiPaper-root-MuiDialog-paper`] : {
          maxWidth: 1000,
          minWidth: 1000,
          minHeight: 450,
          borderRadius: 16
      },
      [`& .jss59 .css-uhb5lp`] : {
        maxWidth: 1000,
        minWidth: 1000,
        minHeight: 450,
        borderRadius: 16
      },
      [`& .css-uhb5lp`]: {
        borderRadius: 12,
        maxWidth: 1000,
        minHeight: 450,
        minWidth: 1000,
      }
      },
    titleModalBank: {
        fontWeight: 400,
        textAlign: 'center',
        fontSize: 24,
        fontFamily: 'Roboto',
        letterSpacing: '0.25px'
      },
    dropdown: {
        backgroundColor: "#EEEEEE",
        boxSizing: "border-box",
        borderRadius: "8px",
        // height: 40,
        fontSize: "14px",
        [`& fieldset`]: {
          borderRadius: 8,
          fontSize: 14,
        },
        '& .css-1u3bzj6-MuiFormControl-root-MuiTextField-root':{
          background: '#dfe7fd',
        },
      },
})